// extracted by mini-css-extract-plugin
export default {"root":"CountryGroupCard_root__58WPa","content":"CountryGroupCard_content__zt4RN","iconBox":"CountryGroupCard_iconBox__ZC-AI","actionMenu":"CountryGroupCard_actionMenu__egXd2"};